import { render, staticRenderFns } from "./K8sServicePanel.vue?vue&type=template&id=c83f22be&"
import script from "./K8sServicePanel.vue?vue&type=script&lang=js&"
export * from "./K8sServicePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports